import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: {},
  loading: false,
  productIds: [],
  variantIds: [],
  subProductIds: [],
  subProductColorIds: [],
  colors: [],
  skus: [],
  error: null,
};

const editPDP = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.EDIT_PRODUCT_DETAILS_LOADING: {
      const newProductIdsArray = [...state.productIds];
      const newVariantIdsArray = [...state.variantIds];
      const newSubProductIdsArray = [...state.subProductIds];
      const newSubProductColorIdsArray = [...state.subProductColorIds];
      const newColorsArray = [...state.colors];
      const newSkusArray = [...state.skus];
      return {
        ...INITIAL_STATE,
        productIds: newProductIdsArray,
        variantIds: newVariantIdsArray,
        subProductIds: newSubProductIdsArray,
        subProductColorIds: newSubProductColorIdsArray,
        colors: newColorsArray,
        skus: newSkusArray,
        loading: true,
      };
    }
    case actions.EDIT_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case actions.EDIT_PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.EDIT_PRODUCT_DETAILS_SET_COLOR_SKU:
      {
        const index = state.productIds.indexOf(payload.productId);
        if (index > -1) {
          const newVariantIdsArray = [...state.variantIds];
          const newSubProductIdsArray = [...state.subProductIds];
          const newSubProductColorIdsArray = [...state.subProductColorIds];
          const newColorsArray = [...state.colors];
          const newSkusArray = [...state.skus];
          newVariantIdsArray[index] = payload.variantId;
          newSubProductIdsArray[index] = payload.subProductId;
          newSubProductColorIdsArray[index] = payload.subProductColorId;
          newColorsArray[index] = payload.color;
          newSkusArray[index] = payload.sku;
          return {
            ...state,
            variantIds: newVariantIdsArray,
            subProductIds: newSubProductIdsArray,
            subProductColorIds: newSubProductColorIdsArray,
            colors: newColorsArray,
            skus: newSkusArray,
            loading: false,
          };
        }
        if (index === -1) {
          return {
            ...state,
            productIds: [...state.productIds, payload.productId],
            variantIds: [...state.variantIds, payload.variantId],
            subProductIds: [...state.subProductIds, payload.subProductId],
            subProductColorIds: [...state.subProductColorIds, payload.subProductColorId],
            colors: [...state.colors, payload.color],
            skus: [...state.skus, payload.sku],
            loading: false,
          };
        }
      }
      break;
    case actions.EDIT_PRODUCT_DETAILS_CLEAR:
      return INITIAL_STATE;
    case actions.EDIT_PRODUCT_DETAILS_PARTIAL_CLEAR:
      return {
        ...state,
        data: {},
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};

export default editPDP;
